<template>
  <div>
    <vmodal
      name="addClientModal"
      height="auto"
      width="920"
      :adaptive="true"
      :scrollable="true"
      class="addClientModal"
    >
      <div class="client-modal card">
        <div class="card-content client-modal__content">
          <div class="client-modal__header">
            <h5 class="client-modal__title">
              {{ editMode ? 'Editează client' : $t('gestiune.addClient') }}
            </h5>
          </div>

          <div class="client-modal__body">
            <div class="row client-modal__toolbar">
              <div class="col-md-6">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.locatie') }}</label>
                  <select class="form-control client-modal__select" v-model="selectedLocationId">
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="String(group.vat)"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.searchClientsWithCUI') }}</label>
                  <form @submit.prevent="searchClient" class="client-modal__search">
                    <input
                      type="text"
                      v-model="searchCUI"
                      class="form-control input-sm"
                      :placeholder="$t('gestiune.searchClientsWithCUI')"
                    />
                    <button type="submit" class="btn btn-primary btn-sm client-modal__search-btn">
                      {{ $t('general.search') }}
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <div class="row client-modal__form-grid">
              <div class="col-md-4">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.companyName') }}*</label>
                  <input type="text" v-model="client.companyName" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.abbreviation') }}*</label>
                  <input type="text" v-model="client.abbreviation" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.CUI') }}*</label>
                  <input type="text" v-model="client.CUI" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.registrationNumber') }}*</label>
                  <input type="text" v-model="client.registrationNumber" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.city') }}*</label>
                  <input type="text" v-model="client.city" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.countries') }}*</label>
                  <input type="text" v-model="client.countries" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.address') }}*</label>
                  <input type="text" v-model="client.address" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.bank') }}*</label>
                  <input type="text" v-model="client.bank" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-5">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.IBAN') }}*</label>
                  <input type="text" v-model="client.IBAN" class="form-control input-sm" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group client-modal__field">
                  <label>{{ $t('gestiune.dueDays') }}*</label>
                  <input type="number" v-model="client.dueDays" class="form-control input-sm" />
                </div>
              </div>
            </div>
          </div>

          <div class="client-modal__footer">
            <a class="btn btn-danger btn-icon delete" @click="closeAddClientModal()">
              {{ $t('general.cancel2') }}
            </a>
            <button class="btn btn-icon btn-success save" @click="saveClient()">
              {{ $t('general.save') }}
            </button>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
  import swal from 'sweetalert2'

  export default {
    data () {
      return {
        selectedVatNumber: null,
        selectedLocationId: '',
        selectedLocation: null,
        vatNumber: null,
        tableData: [],
        client: {
          companyName: '',
          abbreviation: '',
          CUI: '',
          registrationNumber: '',
          address: '',
          city: '',
          countries: '',
          bank: '',
          IBAN: '',
          dueDays: null
        },
        searchCUI: ''
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      getClients: {
        type: Function,
        required: false
      },
      clientData: {
        type: Object,
        default: () => ({})
      },
      editMode: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      selectedLocationId (id) {
        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            break
          }
        }
      },
      selectedVatNumber (newVat) {
        this.selectedVatNumber = newVat
        this.getClients()
      },
      clientData: {
        deep: true,
        immediate: true,
        handler (val) {
          if (!val || !Object.keys(val).length) return

          this.client = this.mapCustomerRowToForm(val)

          if (val.externalLocationId) {
            this.selectedLocationId = val.externalLocationId
          }

          this.$modal.show('addClientModal')
        }
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
    },
    computed: {
      filteredClients () {
        if (!this.searchQuery) {
          return this.tableData
        }

        return this.tableData.filter(client => {
          return client.clientName.toLowerCase().includes(this.searchQuery.toLowerCase())
        })
      }
    },
    methods: {
      mapCustomerRowToForm (row = {}) {
        return {
          companyName: row.companyName || row.clientName || row.name || '',
          abbreviation: row.abbreviation || '',
          CUI: row.CUI || row.vatNumber || row.cui || row.customerVatNumber || '',
          email: row.email || '',
          registrationNumber: row.registrationNumber || '',
          address: row.address || '',
          city: row.city || '',
          countries: row.countries || '',
          bank: row.bank || '',
          IBAN: row.IBAN || row.iban || '',
          dueDays: row.dueDays != null ? row.dueDays : null,
          id: row.id || row._id || null,
          _rev: row._rev || null,
          externalLocationId: row.externalLocationId || null
        }
      },
      openAddClientModal () {
        this.editMode = false
        this.selectedLocationId = ''
        this.searchCUI = ''
        this.client = {
          companyName: '',
          abbreviation: '',
          CUI: '',
          email: '',
          registrationNumber: '',
          address: '',
          city: '',
          countries: '',
          bank: '',
          IBAN: '',
          dueDays: null,
          id: null,
          _rev: null
        }
        this.$modal.show('addClientModal')
      },
      closeAddClientModal () {
        this.editMode = false
        this.$modal.hide('addClientModal')
      },
      editRow (row) {
        this.editMode = true
        this.client = this.mapCustomerRowToForm(row)

        if (row.externalLocationId) {
          this.selectedLocationId = row.externalLocationId
        }

        this.$modal.show('addClientModal')
      },
      async searchClient () {
        try {
          if (!this.searchCUI) {
            swal({
              title: 'Error',
              text: 'Please enter a CUI to search.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
            return
          }

          const company = await this.fetchAnafCompanyByCui(this.searchCUI)
          this.client = this.mapCustomerRowToForm({
            ...this.client,
            companyName: company.name,
            CUI: company.cui || this.client.CUI,
            registrationNumber: company.registrationNumber,
            address: company.address,
            city: company.city,
            countries: company.countryCode,
            IBAN: company.iban
          })
        } catch (error) {
          console.error('Error fetching client details:', error)
          swal({
            title: 'Error',
            text: error.message || 'Failed to retrieve client details.',
            type: 'error',
            timer: 2500,
            showConfirmButton: false
          })
        }
      },
      async saveClient () {
        try {
          if (!this.selectedLocationId || !this.client.CUI || !this.client.companyName || !this.client.address) {
            swal({
              title: 'Error',
              text: 'Toate câmpurile marcate cu * sunt obligatorii.',
              icon: 'error',
              timer: 1500,
              buttons: false
            })
            return
          }

          const selectedLocation = this.groupedLocations
            .flatMap(g => g.locations)
            .find(loc => loc.true_id === this.selectedLocationId)

          if (!selectedLocation) {
            swal({
              title: 'Error',
              text: 'Locația selectată este invalidă.',
              icon: 'error',
              timer: 1500,
              buttons: false
            })
            return
          }

          const clientData = {
            externalCompanyId: this.companyID,
            externalLocationId: selectedLocation.true_id,
            vatNumber: selectedLocation.inv_fiscal_code,
            customerVatNumber: this.client.CUI,
            name: this.client.companyName,
            abbreviation: this.client.abbreviation || '',
            registrationNumber: this.client.registrationNumber || '',
            address: this.client.address,
            city: this.client.city || '',
            countries: this.client.countries || '',
            bank: this.client.bank || '',
            iban: this.client.IBAN || '',
            IBAN: this.client.IBAN || '',
            dueDays: this.client.dueDays != null ? Number(this.client.dueDays) : 0
          }

          if (this.editMode && this.client.id) {
            clientData.id = this.client.id
            if (this.client._rev) {
              clientData._rev = this.client._rev
            }
          }

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/customer`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(clientData)
          })

          if (!response.ok) {
            throw new Error('Eroare la salvarea clientului')
          }

          const responseData = await response.json()
          console.log('Client salvat cu succes:', responseData)

          swal({
            title: 'Succes',
            text: 'Clientul a fost salvat cu succes.',
            icon: 'success',
            timer: 1500,
            buttons: false
          })

          this.$emit('getClients')

          this.$modal.hide('addClientModal')
        } catch (error) {
          console.error('Eroare la salvarea clientului:', error)
          swal({
            title: 'Error',
            text: error.message,
            icon: 'error',
            timer: 1500,
            buttons: false
          })
        }
      }
    }
  }
</script>

<style scoped>
.client-modal__content {
  padding: 0 !important;
}

.client-modal__header {
  padding: 14px 18px 10px;
  border-bottom: 1px solid #ececf1;
}

.client-modal__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #1f2937;
}

.client-modal__body {
  padding: 12px 18px 4px;
  max-height: min(58vh, 520px);
  overflow-y: auto;
}

.client-modal__toolbar {
  margin-bottom: 4px;
}

.client-modal__form-grid {
  margin-top: 0;
}

.client-modal__field {
  margin-bottom: 10px;
}

.client-modal__field label {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}

.client-modal__field .form-control {
  min-height: 38px;
  line-height: 1.4;
  padding: 8px 12px;
  font-size: 14px;
}

.client-modal__select {
  height: 40px;
  line-height: normal;
  padding: 8px 12px;
  appearance: auto;
  -webkit-appearance: menulist;
}

.client-modal__search {
  display: flex;
  gap: 8px;
}

.client-modal__search-btn {
  flex-shrink: 0;
  padding: 6px 16px;
}

.client-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 18px 16px;
  border-top: 1px solid #ececf1;
  background: #fafafa;
}

.client-modal__footer .btn-success {
  background-color: #7ac29a !important;
  border-color: #7ac29a !important;
  color: #fff !important;
  opacity: 1;
}

.client-modal__footer .btn-danger {
  background-color: #f8d7da !important;
  border-color: #f5c2c7 !important;
  color: #b02a37 !important;
  opacity: 1;
}

.client-modal.card {
  margin: 0;
  border: none;
  box-shadow: none;
}
</style>

<style>
.addClientModal .v--modal {
  border-radius: 12px;
  overflow: hidden;
}

.addClientModal .v--modal-box {
  overflow: hidden;
  max-height: 92vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Nomenclator/ManagementClientsAdd.vue